<script lang="ts">
  import Typeahead from "svelte-typeahead";
  import {showSearchBar} from '../state.svelte';
  import {bookmarks} from "./bookmarks";
  let v = $state("");
</script>

{#if showSearchBar.value}
<div class="searchbar">
<Typeahead
  label="Bookmarks"
  hideLabel
  placeholder={`Enter Frequency or Command`}
  data={bookmarks}
  extract={ item => item.getLabel(v) }
  on:select={ event => event.detail.original.runAction(event.detail.searched) }
  on:clear={() => {} }
  disable={ item => item.isDisabled }
  bind:value={v}
>

<svelte:fragment slot="no-results">
    No results found for {v}
</svelte:fragment>

</Typeahead>
</div>
{/if}

<style>
.searchbar :global([data-svelte-typeahead] input) {
    width: 100%;
    padding: 0.5rem 0.5rem;
    font-size: 0.5em;
    border: 0;
    border-radius: 0;
    border: 1px solid #e5e5e5;
  }
</style>
